export default __webpack_public_path__ + "static/media/strasbourg13.913537c2.jpg";